<template>
  <div class="top-lined-row bottom-lined-row">
    <v-btn icon @click.native="clickHandler()">
      <v-icon color="var(--v-resBlue-darken1)">{{icon}}</v-icon>
    </v-btn>
    <span>Unit Type: </span>
    <span class="unit-type-name">{{ params.data.name }}</span>
  </div>
</template>

<script>
  export default {
    name: 'UnitTypeGridHeader',
    components: {
    },
    computed: {
      icon() {
        return this.params.data.allCollapsed(this.params) ? 'mdi-chevron-right' : 'mdi-chevron-down';
      }
    },
    methods: {
      clickHandler: function () {
        this.params.data.onClick(this.params);
      }
    }
  }
</script>

<style scoped lang="scss">
.unit-type-name {
  font-weight: bold;
}
</style>
